import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet, Dimensions } from "react-native";
import apiHelpers from "../../utils/api-helpers";
import { helpers } from "../../utils/helpers";
import CustomImage from "../custom-image";
import TouchableOpacityLink from "../touchable-opacity-link";
import OtrImage from "../../../../assets/img/OTR-Image.png";
import commentIcon from "../../../../assets/img/comment.svg";

const authorAvatarStyle = {
  width: 40,
  height: 40,
  borderRadius: 20,
  outlineWidth: 1,
  outlineOffset: 2,
  outlineColor: "#FC876D",
  outlineStyle: "solid",
};

const OnTheRecord = ({ token }) => {
  const [blogs, setBlogs] = useState([]);
  const [windowWidth, setWindowWidth] = useState(
    Dimensions.get("window").width,
  );

  const getBlogs = async ({ limit, page }) => {
    const endpoint = "/blogs";
    const body = { limit, page };
    try {
      const response = await apiHelpers.apiRequest(
        endpoint,
        body,
        "POST",
        true,
        token,
      );
      if (!response.success || response.code !== "blog_found") {
        throw new Error("Failed to get blogs");
      }
      setBlogs(response.data.story);
    } catch (error) {
      console.log("error in getting blogs", error);
    }
  };

  useEffect(() => {
    getBlogs({ limit: 3, page: 1 });
    const subscription = Dimensions.addEventListener("change", () => {
      setWindowWidth(Dimensions.get("window").width);
    });
    return () => {
      if (subscription?.remove) subscription.remove();
    };
  }, []);

  const isDesktop = helpers.isDesktop();
  const isTablet = windowWidth > 600 && windowWidth <= 991;
  const isMobile = windowWidth <= 600;

  return (
    <View
      style={[
        styles.sectionContainer,
        isMobile && styles.sectionContainerMobile,
      ]}
    >
      {/* Top two-column hero section */}
      <View
        style={[
          styles.topGrid,
          isDesktop ? styles.topGridDesktop : styles.topGridMobile,
        ]}
      >
        {/* Left — Title & description */}
        <View
          style={[
            styles.leftPanel,
            isDesktop && styles.leftPanelDesktop,
            isTablet && styles.leftPanelTablet,
            isMobile && styles.leftPanelMobile,
          ]}
        >
          <Text
            style={[
              styles.heading,
              isDesktop && styles.headingDesktop,
              isTablet && styles.headingTablet,
              isMobile && styles.headingMobile,
            ]}
          >
            On The{"\n"}Record
          </Text>
          <Text
            style={[styles.description, isMobile && styles.descriptionMobile]}
          >
            Essential perspective on journalism from one of its best
            practitioners.
          </Text>
          <TouchableOpacityLink to="/on-the-record">
            <View style={styles.exploreLink}>
              <Text style={styles.exploreLinkText}>Explore Stories</Text>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#e04a2f"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </View>
          </TouchableOpacityLink>
          {isDesktop && <View style={styles.verticalDivider} />}
        </View>

        {/* Right — Background image */}
        <View
          style={[
            styles.rightPanel,
            isDesktop && styles.rightPanelDesktop,
            isTablet && styles.rightPanelTablet,
            isMobile && styles.rightPanelMobile,
          ]}
        >
          <CustomImage
            source={OtrImage}
            altText="Fountain pen on annotated manuscript — On The Record"
            webStyle={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </View>
      </View>
      {/* Featured articles */}
      <View style={styles.articlesSection}>
        <View
          style={[styles.articlesInner, isMobile && styles.articlesInnerMobile]}
        >
          <View
            style={[
              styles.articlesGrid,
              isDesktop && styles.articlesGridDesktop,
              isTablet && styles.articlesGridTablet,
              isMobile && styles.articlesGridMobile,
            ]}
          >
            {blogs &&
              blogs.length > 0 &&
              blogs.map((item) => (
                <View
                  key={item.title}
                  style={{
                    width: "100%",
                    backgroundColor: "#f6f5f3",
                    padding: isDesktop ? 24 : 16,
                    borderColor: "#e7e1da",
                    borderWidth: 1,
                    borderStyle: "solid",
                  }}
                >
                  <TouchableOpacityLink
                    to={`/on-the-record/${item.slug}`}
                    style={{ marginBottom: isDesktop ? 16 : 8 }}
                  >
                    <Text
                      style={[
                        styles.blogTitle,
                        isDesktop && styles.blogTitleDesktop,
                      ]}
                    >
                      {item.title}
                    </Text>
                  </TouchableOpacityLink>
                  <TouchableOpacityLink to={`/on-the-record/${item.slug}`}>
                    <Text
                      style={[
                        styles.blogDesc,
                        isDesktop && styles.blogDescDesktop,
                      ]}
                      numberOfLines={3}
                    >
                      {item.strapline}
                    </Text>
                  </TouchableOpacityLink>
                  <View style={styles.blogDivider} />
                  {/* <View style={styles.blogFooter}>
                    <TouchableOpacityLink
                      to={`/writers/${item.author?.[0]?.slug}`}
                    >
                      <View style={styles.authorRow}>
                        <CustomImage
                          source={item.author?.[0]?.profile_image}
                          altText="Avatar"
                          webStyle={authorAvatarStyle}
                        />
                        <Text style={styles.authorName}>
                          {item.author?.[0]?.name}
                        </Text>
                      </View>
                    </TouchableOpacityLink>
                    <TouchableOpacityLink
                      to={`/on-the-record/${item.slug}?showComment=true`}
                    >
                      <View style={styles.commentRow}>
                        <View
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            window.open(
                              `${window.location.origin}/${item.category.slug}/${item.slug}?showComment=true`,
                              "_self",
                            )
                          }
                        >
                          <CustomImage
                            source={commentIcon}
                            altText="comment"
                            webStyle={{ width: 24, height: 24 }}
                          />
                          <Text style={styles.commentCount}>
                            {item?.comment_count}
                          </Text>
                        </View>
                      </View>
                    </TouchableOpacityLink>
                  </View> */}
                </View>
              ))}
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  sectionContainer: {
    overflow: "hidden",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#e2ddd5",
    width: "100%",
    marginVertical: 80,
  },

  sectionContainerMobile: {
    marginVertical: 40,
  },

  topGrid: {
    backgroundColor: "#e2ddd5",
  },
  topGridDesktop: {
    flexDirection: "row",
    maxHeight: 470,
    minHeight: 470,
  },
  topGridMobile: {
    flexDirection: "column",
  },

  leftPanel: {
    justifyContent: "center",
    backgroundColor: "#f5f0ea",
    position: "relative",
  },
  leftPanelDesktop: {
    flex: 1,
    paddingVertical: 96,
    paddingHorizontal: 64,
  },
  leftPanelTablet: {
    width: "100%",
    paddingVertical: 64,
    paddingHorizontal: 40,
  },
  leftPanelMobile: {
    width: "100%",
    paddingVertical: 48,
    paddingHorizontal: 24,
  },

  heading: {
    fontFamily: "PlayfairDisplay-Bold",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: 1.5,
    marginBottom: 24,
    color: "#e85e30",
  },
  headingDesktop: {
    fontSize: 60,
    lineHeight: 66,
  },
  headingTablet: {
    fontSize: 48,
    lineHeight: 53,
  },
  headingMobile: {
    fontSize: 36,
    lineHeight: 40,
  },

  description: {
    fontSize: 20,
    fontFamily: "HaasGrotesk-Medium",
    lineHeight: 28,
    maxWidth: 400,
    color: "#14181fcc",
  },
  descriptionMobile: {
    fontSize: 18,
    lineHeight: 26,
  },

  exploreLink: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginTop: 32,
  },
  exploreLinkText: {
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "600",
    fontSize: 14,
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#e85e30",
  },

  verticalDivider: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    width: 3,
    backgroundColor: "rgba(224, 74, 47, 0.6)",
  },

  rightPanel: {},
  rightPanelDesktop: {
    flex: 1,
    minHeight: 500,
  },
  rightPanelTablet: {
    width: "100%",
    minHeight: 300,
  },
  rightPanelMobile: {
    width: "100%",
    minHeight: 250,
  },

  articlesSection: {
    backgroundColor: "#fcfaf8",
    borderTopWidth: 1,
    borderTopColor: "#e2ddd5",
  },
  articlesInner: {
    maxWidth: 1240,
    marginHorizontal: "auto",
    paddingVertical: 48,
    paddingHorizontal: 24,
    width: "100%",
  },
  articlesInnerMobile: {
    paddingVertical: 32,
    paddingHorizontal: 16,
  },

  articlesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 24,
  },
  articlesGridDesktop: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  articlesGridTablet: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  articlesGridMobile: {
    gridTemplateColumns: "repeat(1, 1fr)",
  },

  blogTitle: {
    fontFamily: "PlayfairDisplay-Bold",
    fontWeight: "700",
    lineHeight: 36,
    color: "#000000",
    fontSize: 24,
    marginBottom: 8,
  },
  blogTitleDesktop: {
    marginBottom: 16,
  },
  blogDesc: {
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: 0.3,
    color: "#000000",
    fontFamily: "HaasGrotesk-Roman",
    fontWeight: "400",
    marginBottom: 16,
  },
  blogDescDesktop: {
    fontSize: 18,
    lineHeight: 27,
  },
  blogDivider: {
    height: 1,
    width: 100,
    backgroundColor: "#907cff",
    marginTop: 4,
    // marginBottom: 22,
  },
  blogFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  authorRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  authorName: {
    color: "#000000",
    fontSize: 16,
    fontWeight: "400",
    fontFamily: "HaasGrotesk-Roman",
  },
  commentRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  commentCount: {
    fontFamily: "HaasGrotesk-Medium",
    fontSize: 14,
    color: "#6b7280",
    fontWeight: "700",
    lineHeight: 20,
  },
});

export default OnTheRecord;
